import axios from '../index.js';

//查询新闻中心列表
export let getNewsList = (params) => {
    return axios.post(`/client/net/news/list`, params);
};

//查询新闻中心详情
export let getNewsContent = (params) => {
    return axios.get(`/client/net/news/${params}`);
};



// WEBPACK FOOTER //
// ./src/api/net_news/news.js